<template>
  <div>
    <button class="navigation-drawer__toggle" @click.stop="handleMiniDrawer">
      <v-icon v-if="screenWidth < 768">{{ miniDrawer ? 'menu' : 'close' }}</v-icon>
      <v-icon v-else>menu</v-icon>
    </button>

    <!-- :mini-variant.sync="miniDrawer" -->
    <v-navigation-drawer
      v-if="routeName !== 'Welcome'"
      :mini-variant-width="miniVariantWidth"
      :mini-variant="miniDrawer"
      :width="width"
      :app="app"
      disable-resize-watcher
      hide-overlay
      permanent
      fixed
      dark
    >
      <MainMenu :mini-drawer="miniDrawer" @handleMiniDrawer="handleMiniDrawer" />
    </v-navigation-drawer>
  </div>
</template>

<script>
import MainMenu from 'components/MainMenu'

export default {
  name: 'NavigationDrawer',
  props: {
    screenWidth: {
      type: Number
    },

    miniDrawer: {
      type: Boolean
    }
  },
  components: {
    MainMenu
  },
  computed: {
    routeName () {
      return this.$route.name
    },

    miniVariantWidth () {
      return this.screenWidth > 768 ? 72 : 0
    },

    width () {
      return this.screenWidth > 768 ? 256 : 768
    },

    app () {
      return this.screenWidth >= 768
    }
  },
  methods: {
    handleMiniDrawer () {
      this.$emit('handleMiniDrawer')
    }
  }
}
</script>

<style lang="scss">
.v-navigation-drawer {
  overflow: hidden;
}

.navigation-drawer__toggle {
  background-color: transparent;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 36px;
  left: 8px;
  outline: none;
  position: fixed;
  top: 14px;
  transition: background-color .26s ease-in-out;
  width: 36px;
  z-index: 5;

  @media (min-width: 768px) {
    left: 16px;
    top: 39px;
  }

  &:hover {
    background-color: rgba(#fff, .1);
  }

  .v-icon {
    color: #fff;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
